import { render, staticRenderFns } from "./rfqEdit.vue?vue&type=template&id=5a6cfb00&scoped=true&"
import script from "./rfqEdit.vue?vue&type=script&lang=js&"
export * from "./rfqEdit.vue?vue&type=script&lang=js&"
import style0 from "./rfqEdit.vue?vue&type=style&index=0&id=5a6cfb00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6cfb00",
  null
  
)

component.options.__file = "rfqEdit.vue"
export default component.exports